import { RadioField, RadioFieldGroupProps } from '@slal/ui/react-hook-form/fields';
import { memo } from 'react';
import { RadioFieldsContainer } from './styles';

export const RadioFieldGroup = memo(
    ({ name, options, stacked, disabled, required, variant, ...otherProps }: RadioFieldGroupProps) => {
        return (
            <RadioFieldsContainer stacked={stacked} {...otherProps}>
                {options.map(option => (
                    <RadioField
                        key={option.value}
                        name={name}
                        label={option.label}
                        value={option.value}
                        disabled={disabled || option.disabled}
                        required={required}
                        variant={variant}
                    />
                ))}
            </RadioFieldsContainer>
        );
    }
);
